(function(){
'use strict';
var TK=window.TK||{};
window.Shopify=window.Shopify||{};
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
var esc=function(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})};

function money(cents){
  var f=TK.moneyFormat||'${{amount}}';cents=Number(cents)||0;
  function fmt(n,d,t,dec){var s=(n/100).toFixed(d).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,t);return s[1]?s[0]+dec+s[1]:s[0]}
  return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
    if(k==='amount_no_decimals')return fmt(cents,0,',','.');
    if(k==='amount_with_comma_separator')return fmt(cents,2,'.',',');
    if(k==='amount_no_decimals_with_comma_separator')return fmt(cents,0,'.',',');
    if(cents%100===0)return fmt(cents,0,',','.');
    return fmt(cents,2,',','.');
  });
}
TK.money=money;

var tt;function toast(m){var t=$('#tk-toast');if(!t)return;t.textContent=m;t.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){t.classList.remove('show')},2800)}

var lastFocus=null;
function openD(d){if(!d||d.open)return;lastFocus=document.activeElement;d.classList.remove('closing');d.showModal();document.body.classList.add('locked')}
function unlock(){if(!$('dialog[open]'))document.body.classList.remove('locked')}
function closeD(d,now){if(!d||!d.open)return;if(reduce||now){d.classList.remove('closing');d.close();unlock();return}d.classList.add('closing');clearTimeout(d._t);d._t=setTimeout(function(){d.classList.remove('closing');if(d.open)d.close();unlock()},420)}
/* safety net: never leave the page stuck behind a blurred backdrop */
function resetD(){$$('dialog').forEach(function(d){clearTimeout(d._t);d.classList.remove('closing');if(d.open)d.close()});document.body.classList.remove('locked')}
TK.resetDialogs=resetD;
$$('dialog').forEach(function(d){
  d.addEventListener('close',function(){d.classList.remove('closing');clearTimeout(d._t);if(!$$('dialog').some(function(x){return x.open}))document.body.classList.remove('locked');if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true})});
  d.addEventListener('cancel',function(e){e.preventDefault();closeD(d)});
  d.addEventListener('click',function(e){if(e.target===d)closeD(d)});
});
document.addEventListener('click',function(e){
  var o=e.target.closest('[data-open]');
  if(o){e.preventDefault();var id=o.getAttribute('data-open');$$('dialog[open]').forEach(function(x){if(x.id!=='tk-'+id)x.close()});if(id==='cart')renderCart();openD($('#tk-'+id));return}
  var c=e.target.closest('[data-close]');
  if(c){if(c.tagName!=='A')e.preventDefault();closeD(c.closest('dialog'),c.tagName==='A')}
  /* a link inside an open dialog: close it instantly so the next page never inherits the blur */
  var a=e.target.closest('dialog[open] a[href]');if(a&&!a.hasAttribute('data-open'))closeD(a.closest('dialog'),true);
});

var hdr=$('.site-header'),ann=$('.announce');
function onScroll(){if(hdr&&document.body.classList.contains('is-home'))hdr.classList.toggle('solid',scrollY>60)}
if(ann)document.documentElement.style.setProperty('--announce-h',ann.offsetHeight+'px');
addEventListener('scroll',function(){requestAnimationFrame(onScroll)},{passive:true});onScroll();

var cartBusy=false;
function setCount(n){$$('.bag-count').forEach(function(b){if(b.textContent!==String(n)){b.textContent=n;b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump')}})}
function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
function lineHTML(it,i){
  var v='';
  if(it.options_with_values&&it.variant_title&&it.variant_title!=='Default Title'){v=it.options_with_values.map(function(o){return o.name==='Value'?esc(o.value):esc(o.name)+' '+esc(o.value)}).join(', ')}
  return '<div class="line" style="animation-delay:'+(i*.06)+'s"><a href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="" width="84" height="84" loading="lazy">':'')+'</a>'+
  '<div><h3><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a></h3><div class="meta">'+v+'</div>'+
  '<div><span class="qty"><button type="button" data-qty="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'" aria-label="One less">&minus;</button><span>'+it.quantity+'</span><button type="button" data-qty="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'" aria-label="One more">+</button></span><button type="button" class="remove" data-qty="'+esc(it.key)+'" data-q="0">Remove</button></div></div>'+
  '<div class="price">'+money(it.final_line_price)+'</div></div>';
}
function paint(cart){
  setCount(cart.item_count);
  var body=$('#tk-cart-body'),foot=$('#tk-cart-foot');if(!body)return;
  if(!cart.item_count){body.innerHTML='<div class="empty"><h3>Your bag is empty</h3><p>Every set is made in one small batch.</p><a class="btn" href="'+esc(TK.collectionsUrl||'/collections')+'"><span>Explore the collections</span></a></div>';foot.hidden=true;return}
  body.innerHTML=cart.items.map(lineHTML).join('');
  foot.hidden=false;$('#tk-subtotal').textContent=money(cart.total_price);
  var sv=$('#tk-saving');if(sv){var d=cart.total_discount||0;sv.hidden=!d;if(d)$('b',sv).textContent='-'+money(d)}
}
function renderCart(){return fetch((TK.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(paint).catch(function(){})}
function addToCart(id,qty,btn){
  if(cartBusy)return Promise.resolve();cartBusy=true;if(btn)btn.classList.add('is-busy');
  return fetch((TK.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})})
  .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
  .then(function(){return renderCart()})
  .then(function(){$$('dialog[open]').forEach(function(x){x.close()});openD($('#tk-cart'))})
  .catch(function(err){toast((err&&err.description)||'Something went wrong. Please try again.')})
  .finally(function(){cartBusy=false;if(btn)btn.classList.remove('is-busy')});
}
TK.addToCart=addToCart;
document.addEventListener('click',function(e){
  var q=e.target.closest('[data-qty]');
  if(q){e.preventDefault();fetch((TK.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:q.getAttribute('data-qty'),quantity:Number(q.getAttribute('data-q'))})}).then(function(r){return r.json()}).then(function(c){paint(c);if(document.body.classList.contains('is-cart')&&!q.closest('dialog'))location.reload()});return}
  var chip=e.target.closest('[data-quick]');
  if(chip){e.preventDefault();addToCart(chip.getAttribute('data-quick'),1,chip).then(function(){chip.classList.add('done');setTimeout(function(){chip.classList.remove('done')},1600)})}
});

function initProduct(root){
  $$('[data-product]',root).forEach(function(el){
    if(el.dataset.ready)return;el.dataset.ready=1;
    var data;try{data=JSON.parse($('script[type="application/json"]',el).textContent)}catch(e){return}
    var form=$('form[action*="/cart/add"]',el);if(!form)return;
    var opt=el.dataset.opt||'Size',isVal=opt==='Value',buyLabel=el.dataset.label||TK.buyLabel||'Pre-order';
    var idIn=$('input[name="id"]',form),btn=$('.buy',el),chosen=$('.chosen',el),price=$('.price',el),cmp=$('.compare',el),err=$('.form-error',el),sbtn=$('.sticky-buy .btn',el),ssize=$('.sticky-buy small',el),radios=$$('input[type="radio"]',el);
    function nm(v){return isVal?v.title:opt+' '+v.title}
    function pick(v,push){
      if(!v)return;idIn.value=v.id;
      if(chosen)chosen.textContent=nm(v);
      if(price)price.textContent=money(v.price);
      if(cmp)cmp.textContent=v.compare>v.price?money(v.compare):'';
      var label=v.available?buyLabel:'Sold out';
      btn.disabled=!v.available;$('span',btn).textContent=label+' · '+money(v.price);
      if(sbtn){sbtn.disabled=!v.available;$('span',sbtn).textContent=label}
      if(ssize)ssize.textContent=nm(v)+' · '+money(v.price);
      if(push&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u)}
    }
    radios.forEach(function(r){r.addEventListener('change',function(){err.textContent='';pick(data.find(function(v){return String(v.id)===r.value}),true)})});
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(radios.length&&!$('input[type="radio"]:checked',el)){err.textContent='Choose your '+opt.toLowerCase()+' first.';var f=$('.sizes',el);if(f)f.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});return}
      addToCart(idIn.value,1,btn);
    });
    if(sbtn)sbtn.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else form.dispatchEvent(new Event('submit',{cancelable:true}))});
    var checked=$('input[type="radio"]:checked',el);if(checked)pick(data.find(function(v){return String(v.id)===checked.value}),false);
    var sticky=$('.sticky-buy',el);
    if(sticky&&'IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(x){sticky.classList.toggle('show',!x.isIntersecting&&x.boundingClientRect.top<0)})}).observe(btn)}
  });
  $$('.gallery',root).forEach(function(g){
    if(g.dataset.ready)return;g.dataset.ready=1;
    var stage=$('.stage',g),main=stage&&$('img',stage);if(!main)return;
    $$('.thumbs button',g).forEach(function(b){b.addEventListener('click',function(){
      $$('.thumbs button',g).forEach(function(x){x.setAttribute('aria-current','false')});b.setAttribute('aria-current','true');
      stage.classList.add('swap');setTimeout(function(){main.onload=function(){stage.classList.remove('swap')};main.srcset=b.dataset.srcset||'';main.src=b.dataset.src},250);
    })});
    stage.addEventListener('pointermove',function(e){var r=stage.getBoundingClientRect();stage.style.setProperty('--zx',((e.clientX-r.left)/r.width*100)+'%');stage.style.setProperty('--zy',((e.clientY-r.top)/r.height*100)+'%')});
    stage.addEventListener('click',function(){stage.classList.toggle('zoom')});
    stage.addEventListener('pointerleave',function(){stage.classList.remove('zoom')});
  });
}

function initHero(root){
  $$('[data-lamp]',root).forEach(function(hero){
    if(hero.dataset.ready||reduce)return;hero.dataset.ready=1;
    var press=$('.press',hero),tx=.5,ty=.45,cx=.5,cy=.45,idle=-1e9,t0=performance.now();
    hero.addEventListener('pointermove',function(e){var r=hero.getBoundingClientRect();tx=(e.clientX-r.left)/r.width;ty=(e.clientY-r.top)/r.height;idle=performance.now()});
    (function loop(now){
      if(!document.body.contains(hero))return;
      if(now-idle>2500){var t=(now-t0)/1000;tx=.5+Math.sin(t*.35)*.24;ty=.45+Math.cos(t*.27)*.12}
      cx+=(tx-cx)*.06;cy+=(ty-cy)*.06;
      var hr=hero.getBoundingClientRect();
      if(hr.bottom>0){hero.style.setProperty('--x',(cx*100)+'%');hero.style.setProperty('--y',(cy*100)+'%');
      if(press){var pr=press.getBoundingClientRect();press.style.setProperty('--lx',(cx*hr.width-(pr.left-hr.left))+'px');press.style.setProperty('--ly',(cy*hr.height-(pr.top-hr.top))+'px')}}
      requestAnimationFrame(loop);
    })(performance.now());
  });
}

var wordSets=[];
function initWords(root){
  $$('[data-words]',root).forEach(function(h){
    if(h.dataset.ready)return;h.dataset.ready=1;
    var gold={};(h.getAttribute('data-gold')||'').split(',').forEach(function(w){w=w.trim().toLowerCase();if(w)gold[w]=1});
    h.innerHTML=h.textContent.trim().split(/\s+/).map(function(w){var k=w.toLowerCase().replace(/[^a-z0-9']/g,'');return '<span'+(gold[k]?' class="gold"':'')+'>'+esc(w)+'</span>'}).join(' ');
    if(reduce){$$('span',h).forEach(function(s){s.classList.add('on')});return}
    wordSets.push({h:h,s:$$('span',h)});
  });
}
function lightWords(){wordSets.forEach(function(o){var r=o.h.getBoundingClientRect(),vh=innerHeight;var p=Math.min(1,Math.max(0,(vh*.85-r.top)/(r.height+vh*.3)));var n=Math.round(p*o.s.length);o.s.forEach(function(s,i){s.classList.toggle('on',i<n)})})}
addEventListener('scroll',function(){requestAnimationFrame(lightWords)},{passive:true});

var io='IntersectionObserver' in window&&!reduce?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('pre');e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12}):null;
function initReveal(root){
  $$('[data-reveal]',root).forEach(function(el){
    if(el.dataset.rv)return;el.dataset.rv=1;
    if(!io||Shopify.designMode){el.classList.add('in');return}
    el.classList.add('rv');
    if(el.getBoundingClientRect().top>innerHeight*.95){el.classList.add('pre');io.observe(el)}else el.classList.add('in');
  });
}

function init(root){initHero(root);initWords(root);initReveal(root);initProduct(root);lightWords()}
init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
addEventListener('pageshow',function(e){if(e.persisted){resetD();renderCart()}});
addEventListener('pagehide',resetD);
/* skip the page fade if a dialog is still open when leaving, and on the new page if anything went wrong */
addEventListener('pageswap',function(e){if(e.viewTransition&&$('dialog[open]'))e.viewTransition.skipTransition();resetD()});
document.addEventListener('visibilitychange',function(){if(document.visibilityState!=='visible')return;$$('dialog[open]').forEach(function(d){var r=d.getBoundingClientRect();if(d.classList.contains('closing')||r.width<2||r.height<2||getComputedStyle(d).opacity==='0'){d.classList.remove('closing');d.close()}});if(!$('dialog[open]'))document.body.classList.remove('locked')});
})();